require('./bootstrap');

import { createRoot } from 'react-dom/client';
import { createInertiaApp } from '@inertiajs/inertia-react';
import { InertiaProgress } from '@inertiajs/progress';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { Inertia } from '@inertiajs/inertia';

i18n.use(initReactI18next).init({
    resources: {
        en: {
            translation: require('../lang/en')
        },
        pt: {
            translation: require('../lang/pt')
        }
    },
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false
    }
});

const initialProps = window.document.getElementById('app')?.dataset.page;

const appName = initialProps ? JSON.parse(initialProps).props.name : '';

createInertiaApp({
    resolve: (name) => import(`./Pages/${name}`),
    title: (title) => {
        return `${title} - ${appName}`;
    },
    setup({ el, App, props }) {
        i18n.changeLanguage(props.initialPage.props.locale);
        return createRoot(el).render(<App {...props} />);
    }
});

InertiaProgress.init({ color: '#4B5563' });

Inertia.on('navigate', (event) => {
    i18n.changeLanguage(event.detail.page.props.locale);

    Ziggy.defaults.language = event.detail.page.props.locale;

    if (typeof gtag !== 'undefined') {
        gtag('event', 'page_view', {
            page_location: event.detail.page.url
        });
    }

    // force scroll to top on navigate
    window.scrollTo(0, 0);
});
